export type Tone = 'neutral' | 'good' | 'warn' | 'danger' | 'blue';

const tones: Record<Tone, string> = {
  neutral: 'border-clinical-line bg-clinical-surface text-clinical-muted',
  good: 'border-emerald-300/60 bg-emerald-500/10 text-emerald-700 dark:text-emerald-300',
  warn: 'border-amber-300/60 bg-amber-500/10 text-amber-800 dark:text-amber-300',
  danger: 'border-red-300/60 bg-red-500/10 text-red-800 dark:text-red-300',
  blue: 'border-blue-300/60 bg-blue-500/10 text-blue-800 dark:text-blue-300'
};

export function StatusBadge({ children, tone = 'neutral' }: { children: React.ReactNode; tone?: Tone }) {
  return <span className={`inline-flex rounded-full border px-2.5 py-1 text-xs font-medium ${tones[tone]}`}>{children}</span>;
}
